export const BATTLE_TRAITS_PNEX = [
    {
        name: 'Personaggio',
        keywords_a: ['character'],
        keywords_r: ['monster', 'vehicle'],
        dices: {
            "1": {
                name: 'LEAD FROM THE FRONT',
                flavor: 'Amidst the horror and confusion of war in the Nephilim Anomaly, dynamic war leaders can make a great difference.',
                description: 'This unit has the Infiltrators ability.'
            },
            "2": {
                name: 'HORROR-HARDENED',
                flavor: 'Nothing in this nightmarish war zone now has the power to distract this hardened veteran from their duty.',
                description: 'You can target this unit with Stratagems even while it is Battle-shocked.'
            },
            "3": {
                name: 'ARCH ACQUISITOR',
                flavor: 'The relentless hunt for Noctilith has focussed this warrior on seizing battlefield objectives at all costs.',
                description: 'Add 3 to the Objective Control characteristic of one CHARACTER model in this unit.'
            },
            "4": {
                name: 'CLAIM STALKER',
                flavor: 'Bitter experience has taught this commander to seize contested battlefield prizes with caution.',
                description: 'While this unit is within range of an objective marker, it has the Stealth ability.'
            },
            "5": {
                name: 'HEROIC CONSTITUTION',
                flavor: 'This exemplary commander can endure the most nightmarish hardships and fight on with soul and body unflagging.',
                description: 'Add 1 to the Wounds characteristic of one CHARACTER model in this unit.'
            },
            "6": {
                name: 'DUELLIST',
                flavor: 'Many a duel of martial champions has been fought in the Nephilim Sector, sometimes deciding the fates of entire war fronts!',
                description: 'Each time a Character model in this unit makes a melee attack that targets a CHARACTER unit, you can re-roll the Hit roll.'
            },
            "pnex-1": {
                name: 'NODAL MAP',
                flavor: 'With each fresh blackstone deposit discovered and recorded, it becomes ever easier to determine where the next such hidden prize may be secured.',
                description: 'While the bearer is within range of an objective marker, if the bearers unit is Battle-shocked, change the Objective Control characteristic of models in that unit to 1, instead of 0.',
                fragments: 20,
            },
            "pnex-2": {
                name: 'SINGLE-MINDED SEEKER',
                flavor: 'Locating the strange riches of this region only feeds this commander’s desire to accrue more such esoteric wealth.',
                description: 'If the bearer is your Warlord, at the end of the battle, roll one D6, adding 2 to the roll if you won the battle. On a 6+, you gain 3 Blackstone Fragments.',
                fragments: 10,
            },
            "pnex-3": {
                name: 'ACQUISITIVE OPPORTUNIST',
                flavor: 'Thanks to the stifling effects of the nodal matrix, many commanders fighting in this region are forced to do so in relative ignorance or while wrestling with the nightmare effects of the Stilling. This warlord has become adept at recognising these weaknesses in their foes and adapting accordingly.',
                description: 'At the start of the battle, if the bearer is your WARLORD, until the end of the battle, it gains the ability below that corresponds with the Strategic Footing you selected in the Select Strategic Footing step:\r\nAggressive: Models in the bearer’s unit have the Scouts 6" ability.\r\nBalanced: The bearer has the Lone Operative ability.\r\nDefensive: Models in the bearer’s unit have the Stealth ability.',
                fragments: 15,
            },

        }
    },
    {
        name: 'Veicoli',
        keywords_a: ['vehicle'],
        keywords_r: [],
        dices: {
            "1": {
                name: 'HARDENED DEFENCES',
                flavor: 'Amidst the gruelling hardships of this war zone, this unit has undergone battlefield bolstering and repair by the warriors it fights alongside.',
                description: 'Models in this unit have the Feel No Pain 6+ ability.',
            },
            "2": {
                name: 'TOTEMIC PRESENCE',
                flavor: 'This unit has come to be seen as an icon of victory and conquest by its comrades.',
                description: 'Add 2 to the Objective Control characteristic of one model in this unit.',
            },
            "3": {
                name: 'TANK HUNTER',
                flavor: 'Amidst the strained supply lines of the war zone, eliminating irreplaceable enemy assets is a valuable skill.',
                description: 'Each time a model in this unit makes an attack that targets a MONSTER or VEHICLE unit, re-roll a Wound roll of 1.',
            },
            "4": {
                name: 'STUBBORN EXPLORATOR',
                flavor: 'The heaped bodies, abandoned ruins and war-torn dig sites of this war zone are no obstacle to this bulldozing behemoth.',
                description: 'Each time this unit makes a Normal or Advance move, it can move over terrain features that are 4" or less in height as if they were not there.',
            },
            "5": {
                name: 'HEAVILY ARMOURED',
                flavor: 'It takes fortitude and fortune to survive long beneath the shroud of the nodal matrix.',
                description: 'Once per battle, when an attack is allocated to a model in this unit, you can change the Damage characteristic of that attack to 0.',
            },
            "6": {
                name: 'REAPER',
                flavor: 'Infantry fall like wheat before the scythe of this terrible slaughterer’s weapons.',
                description: 'Each time a model in this unit makes an attack that targets an INFANTRY or MOUNTED unit, re-roll a Hit roll of 1.',
            },
        }
    },
    {
        name: 'Mostri',
        keywords_a: ['monster'],
        keywords_r: [],
        dices: {
            "1": {
                name: 'HARDENED DEFENCES',
                flavor: 'Amidst the gruelling hardships of this war zone, this unit has undergone battlefield bolstering and repair by the warriors it fights alongside.',
                description: 'Models in this unit have the Feel No Pain 6+ ability.',
            },
            "2": {
                name: 'TOTEMIC PRESENCE',
                flavor: 'This unit has come to be seen as an icon of victory and conquest by its comrades.',
                description: 'Add 2 to the Objective Control characteristic of one model in this unit.',
            },
            "3": {
                name: 'TANK HUNTER',
                flavor: 'Amidst the strained supply lines of the war zone, eliminating irreplaceable enemy assets is a valuable skill.',
                description: 'Each time a model in this unit makes an attack that targets a MONSTER or VEHICLE unit, re-roll a Wound roll of 1.',
            },
            "4": {
                name: 'STUBBORN EXPLORATOR',
                flavor: 'The heaped bodies, abandoned ruins and war-torn dig sites of this war zone are no obstacle to this bulldozing behemoth.',
                description: 'Each time this unit makes a Normal or Advance move, it can move over terrain features that are 4" or less in height as if they were not there.',
            },
            "5": {
                name: 'HEAVILY ARMOURED',
                flavor: 'It takes fortitude and fortune to survive long beneath the shroud of the nodal matrix.',
                description: 'Once per battle, when an attack is allocated to a model in this unit, you can change the Damage characteristic of that attack to 0.',
            },
            "6": {
                name: 'REAPER',
                flavor: 'Infantry fall like wheat before the scythe of this terrible slaughterer’s weapons.',
                description: 'Each time a model in this unit makes an attack that targets an INFANTRY or MOUNTED unit, re-roll a Hit roll of 1.',
            },
        }
    },
    {
        name: 'Fanteria',
        keywords_a: ['infantry'],
        keywords_r: ['character'],
        dices: {
            "1": {
                name: 'BATTLE-SCARRED RESISTANCE',
                flavor: 'No matter the hardships and horrors these warriors face, still they forge on un-Stilled and unstoppable.',
                description: 'Models in this unit have the Feel No Pain 6+ ability.',
            },
            "2": {
                name: 'WRAITH OF RUIN',
                flavor: 'These warriors employ the apocalyptic ruinscapes of the Nephilim Anomaly to mask their advance.',
                description: 'Models in this unit have the Infiltrators ability.',
            },
            "3": {
                name: 'UNITED BY ADVERSITY',
                flavor: 'This unit watch over their allies, knowing that in this dread war zone isolation means death.',
                description: 'You can target this unit with the Heroic Intervention Stratagem for 0CP, and can do so even if you have already targeted a different unit with that Stratagem this phase.',
            },
            "4": {
                name: 'RAIDERS',
                flavor: 'This squad are adept at seizing blackstone and other riches from their foes.',
                description: 'Each time a model in this unit makes an attack that targets a unit that is within range of an objective marker, re-roll a Hit roll of 1.',
            },
            "5": {
                name: 'PURGATORS',
                flavor: 'These warriors have become quick to resort to extreme - explosive - measures.',
                description: 'This unit gains the GRENADES keyword. If it already has that keyword, once per battle, you can target this unit with the Grenade Stratagem for 0CP.',
            },
            "6": {
                name: 'TERROR ASSAULT',
                flavor: 'Fighting so long amongst such horrifying environs has left a dread mark upon these warriors, which they exploit gladly.',
                description: 'At the start of the Fight phase, select one enemy unit within Engagement Range of this unit. That enemy unit musttake a Battle-shock test.',
            },
        },
    },
    {
        name: 'A cavallo',
        keywords_a: ['mounted'],
        keywords_r: ['character'],
        dices: {
            "1": {
                name: 'RIDERS OF RUIN',
                flavor: 'These warriors have become adept at picking a path through the haunted ruins of the Nephilim Sector.',
                description: 'Add 2" to the Move characteristic of models in this unit.',
            },
            "2": {
                name: 'THUNDERING ONSLAUGHT',
                flavor: 'No foe can escape when these warriors sweep down upon them from the wastes.',
                description: 'Add 1 to Advance and Charge rolls made for this unit.',
            },
            "3": {
                name: 'SADDLEBORNE ASSASSINS',
                flavor: 'These warriors exploit the often-confused nature of war in the anomaly to close swiftly upon unsuspecting prey and gun them down at close quarters.',
                description: 'Each time a model in this unit makes a ranged attack that targets the closest eligible target, improve the Armour Penetration characteristic of that attack by 1.	',
            },
            "4": {
                name: 'LINEBREAKERS',
                flavor: 'After many desperate melees, these warriors have become skilled in striking hard and tearing through the enemy lines.',
                description: 'Each time this unit ends a Charge move, until the end of the turn, melee weapons equipped by models in this unit have the [SUSTAINED HITS 1] ability.',
            },
            "5": {
                name: 'CRUSHING CHARGE',
                flavor: 'These warriors have become quick to resort to extreme - explosive - measures.',
                description: 'Each time this unit ends a Charge move, select one enemy within Engagement Range of it, then roll one D6 for each model in this unit that is within Engagement Range of that enemy unit: for each 4+, that enemy unit suffers 1 mortal wound.',
            },
            "6": {
                name: 'BLUR OF SPEED',
                flavor: 'This unit push their speed to the maximum, relying on it to confound their enemies’ aim.',
                description: 'Models in this unit have the Stealth ability.	',
            },
        },
    },

]

















